import { db } from '@/db'
import Dexie, { Table, liveQuery } from 'dexie';
import { SystemToDo } from "@/models/SystemToDo";
import { ref, onMounted, onUnmounted, isProxy, toRaw  } from 'vue'
import { type } from 'jquery';

export interface IDataSafe {
    id?: number;
    appUser: string;
    attribute: number;
    value: string;
    valueTSfrom: number;
    valueTSto: number;
    valueTSinsert: number;
    serverId: number;
    serverIdUpdateTS: number;
  }


  
export class DataSafe implements IDataSafe {
  //datasafe!: Dexie.Table<IDataSafe, number>;
  id!: number;
  appUser: string;
  attribute: number;
  value: string;
  valueTSfrom: number;
  valueTSto: number;
  valueTSinsert: number;
  serverId: number;
  serverIdUpdateTS: number;

  constructor(appUser: string, attribute: number, value: string, valueTSfrom: number, valueTSto: number, valueTSinsert: number, serverId: number,serverIdUpdateTS: number, id?:number) {
    this.appUser = appUser;
    this.attribute = attribute;
    this.value = value;
    this.valueTSfrom = valueTSfrom;
    this.valueTSto = valueTSto;
    this.valueTSinsert = valueTSinsert;
    this.serverId= serverId;
    this.serverIdUpdateTS = serverIdUpdateTS;
    if (id) this.id = id;
  }

  async insertOrUpdateFHIRServerReturn(){
    let values = DataSafe.convertThisToDatasafeValueObj(this);
    let insertId = 0;
    if(typeof this.id != 'undefined'){

      return await db.datasafe.update(this.id,this).then((id) =>{
        return SystemToDo.addToToDo(this.appUser,'updateRowOnServer',id)
      })
    }else{
      return await db.datasafe.add(this).then((id) =>{
        return SystemToDo.addToToDo(this.appUser,'insertRowOnServer',id).then((res) =>{
        })
      })
    }
  }


  async insertOrUpdateServerReturn(){
    let values = DataSafe.convertThisToDatasafeValueObj(this);
    return await db.datasafe.put(this,this.id)
  }

  static convertThisToDatasafeValueObj(ThisValues: Object){
    let keys = Object.keys(ThisValues);
    let Ret = {};
    for(var i=0; i < keys.length;i++) {
      if(keys[i] != 'id'){
        /*@ts-ignore*/
        Ret[keys[i]] = ThisValues[keys[i]];
      }
    }
    return Ret;
  }

  static leadingZero(val: number){
    //console.log(val);
    return (val < 10 ? '0' : '') + val;
  }

  static getMainClassAttributes(){
    let Help = Object.keys(new DataSafe('',0,'',0,0,0,0,0 ));
    if(Help.includes('datasafe'))Help.splice(Help.indexOf('datasafe'),1);
    if(Help.includes('datasafe'))Help.splice(Help.indexOf('datasafe'),1);

    return Help;
  }

  static valToKeyCheck(val: any,key: any){
    switch(key){
      case "id":
        val = parseInt(val);
        if(typeof val == 'number'){
          return val;
        }else{
          return false;
        }
        break;
      case "appUser":
        if(val.length > 7){
          return val;
        }else{
          return false;
        }
        break;
      case "attribute":
        let checkVal;
        
        if(typeof val != "string"){
          checkVal = val.toString();
        }else{
          checkVal=val;
        }
        
        let myAttributeNumbers = Object.keys(DataSafe.myAttributes());

        if(myAttributeNumbers.includes(checkVal)){
          return parseInt(val);
        }else{
          return false;
        }
        break;
      case "value":
        switch(val){
          case "true":
            return true;
            break;
          case "false":
            return false;
            break;
          default:
            return val;
            break;
        }
        break;
      case "valueTSfrom":
        val = parseInt(val);
        if((val.toString().length == '1687442385433'.toString().length)){
          return val;
        }else{
          //console.log('valueTSfrom false check:' + val)
          return false;
        }
        break;
      case "valueTSto":
        val = parseInt(val);
        if((val.toString().length == '1687442385433'.toString().length)
        || (val.toString().length == 1 && val == 0)){
          return val;
        }else{
          if(val == "0"){
            return 0;
          }else{
            return false;
          }
        }
        break;
      case "valueTSinsert":
        val = parseInt(val);
        if((val.toString().length == '1687442385433'.toString().length)){
          return val;
        }else{
          return false;
        }
        break;
      case "serverId":
        val = parseInt(val);
        if(typeof val == 'number'){
          return val;
        }else{
          return false;
        }
        break;
      case "serverIdUpdateTS":
          val = parseInt(val);
          if((val.toString().length == '1687442385433'.toString().length)){
            return val;
          }else{
            return false;
          }
          break;
      default:
        return false;
    }
  }

  static getInsertOrUpdateFunctionToAttribute(attr: any){
    switch(attr){
      case 30:
        return 'insertOrUpdateSingleRowToDate';
        break;
      default:
        return 'insertOrUpdateToDate';
      break;
    }
  }


  static getDataAttributeNumbers(){
    let nbs = [];
    for(var i = 10; i <900; i++){
      nbs.push(i)
    }
    return nbs;
  }

  static myAttributes(){
    const attributes = [];
    // Profile:
    attributes[0] = "Profile_birthdate";
    attributes[1] = "Profile_cyclelength";
    attributes[2] = "Profile_periodlength";
    attributes[3] = "Profile_cycle";
    attributes[4] = "Profile_destination";
    attributes[5] = "Persona_Profiles";

    //attributes[10] = "Mood_fearful";
    attributes[11] = "Mood_happy";
    attributes[12] = "Mood_calm";
    attributes[13] = "Mood_confident";
    attributes[14] = "Mood_sexy";
    attributes[15] = "Mood_angry";
    attributes[16] = "Mood_emotional";
    attributes[17] = "Mood_stressed";
    attributes[18] = "Mood_tired";

    attributes[30] = "Notes_Note";

    attributes[31] = "Symptoms_acne";
    //attributes[32] = "Symptoms_all_right";
    //attributes[33] = "Symptoms_flatulence";
    attributes[34] = "Symptoms_breast tenderness";
    //attributes[35] = "Symptoms_perineal_pain";
    //attributes[36] = "Symptoms_diarrhea";
    attributes[37] = "Symptoms_hot hunger";
    attributes[38] = "Symptoms_headache";
    attributes[39] = "Symptoms_cramps";
    attributes[40] = "Symptoms_fatigue";
    //attributes[41] = "Symptoms_insomnia";
    //attributes[42] = "Symptoms_swelling";
    attributes[43] = "Symptoms_abdominal pain";
    //attributes[44] = "Symptoms_constipation";
    attributes[45] = "Symptoms_no symptoms";
    attributes[46] = "Symptoms_backache";

    attributes[49] = "PeriodDay_weak";
    attributes[50] = "PeriodDay_medium";
    attributes[51] = "PeriodDay_strong";
    attributes[52] = "PeriodDay_very strong";

    attributes[60] = "Activity_no training";
    attributes[61] = "Activity_swimming";
    attributes[62] = "Activity_yoga";
    attributes[63] = "Activity_cycling";
    attributes[64] = "Activity_running";
    attributes[65] = "Activity_fitness";
    attributes[66] = "Activity_teamsport";
    attributes[67] = "Activity_walking";
    attributes[68] = "Activity_dancing";

    attributes[80] = "Miscellaneous_stress";
    attributes[81] = "Miscellaneous_traveling";
    attributes[82] = "Miscellaneous_alcohol";
    attributes[83] = "Miscellaneous_illness";
    attributes[84] = "Miscellaneous_meditation";  

    attributes[98] = "Pain_Pain";
    attributes[99] = "Temperature_Temperature";

    attributes[110] = "Sex and libido_no sex";
    attributes[111] = "Sex and libido_protected sex";
    attributes[112] = "Sex and libido_oralsex";
    attributes[113] = "Sex and libido_unprotected sex";
    attributes[114] = "Sex and libido_analsex";
    attributes[115] = "Sex and libido_strong libido";
    attributes[116] = "Sex and libido_neutral libido";
    attributes[117] = "Sex and libido_low libido";
    attributes[118] = "Sex and libido_orgasm";    

    attributes[130] = "Cycle_Cycle length";
    attributes[131] = "Cycle_Period duration";
    attributes[132] = "Cycle_Fertility period (Estimated)";
    attributes[133] = "Cycle_Date of ovulation (Estimated)"; 
    attributes[134] = "Cycle_First Date last period"; 

    // Other:
    attributes[900] = "SharedData_ObservationLastMenstrualPeriod";
    attributes[901] = "SharedData_Painlevel";
    attributes[902] = "SharedData_toRowIds";

    // Smart Wearables
    attributes[10000] = "Smart Wearables_Steps";
    attributes[10001] = "Smart Wearables_CoveredDistance";
    attributes[10002] = "Smart Wearables_FloorsClimbed";
    attributes[10003] = "Smart Wearables_BurnedCalories";
    attributes[10004] = "Smart Wearables_ActiveBurnedCalories";
    attributes[10005] = "Smart Wearables_ActivityDuration";
    attributes[10006] = "Smart Wearables_ActiveDuration";
    attributes[10007] = "Smart Wearables_SleepDuration";
    attributes[10008] = "Smart Wearables_SleepInBedDuration";
    attributes[10009] = "Smart Wearables_SleepREMDuration";
    attributes[10010] = "Smart Wearables_SleepDeepDuration";
    attributes[10011] = "Smart Wearables_SleepStartTime";
    attributes[10012] = "Smart Wearables_SleepEndTime";
    attributes[10013] = "Smart Wearables_SleepEfficiency";
    attributes[10014] = "Smart Wearables_HeartRate";
    attributes[10015] = "Smart Wearables_HeartRateResting";

    return attributes;
  }

  static myAttributesDe(){
    const attributes = [];
    // Profile:
    attributes[0] = "Profil_Geburtsdatum";
    attributes[1] = "Profil_Zykluslänge ";
    attributes[2] = "Profil_Periodenlänge ";
    attributes[3] = "Profil_Zyklus";
    attributes[4] = "Profil_Ziel";
    attributes[5] = "Persona_Profile";

    //attributes[9] = "SharedData";

    //attributes[10] = "Stimmung_ängstlich";
    attributes[11] = "Stimmung_Glücklich";
    attributes[12] = "Stimmung_Gelassen";
    attributes[13] = "Stimmung_Selbstbewusst";
    attributes[14] = "Stimmung_Sexy";
    attributes[15] = "Stimmung_Wütend";
    attributes[16] = "Stimmung_Emotional";
    attributes[17] = "Stimmung_Gestresst";
    attributes[18] = "Stimmung_Müde";

    attributes[30] = "Notizen_Notiz";

    attributes[31] = "Symptome_Akne";
    //attributes[32] = "Symptome_Alles in Ordnung";
    //attributes[33] = "Symptome_Blähungen";
    attributes[34] = "Symptome_Brustspannen";
    //attributes[35] = "Symptome_Dammschmerzen";
    //attributes[36] = "Symptome_Durchfall";
    attributes[37] = "Symptome_Heißhunger";
    attributes[38] = "Symptome_Kopfschmerzen";
    attributes[39] = "Symptome_Krämpfe";
    attributes[40] = "Symptome_Müdigkeit";
    //attributes[41] = "Symptome_Schlaflosigkeit";
    //attributes[42] = "Symptome_Schwellung";
    attributes[43] = "Symptome_Unterleibschmerzen";
    //attributes[44] = "Symptome_Verstopfung";
    attributes[45] = "Symptome_Keine Symptome";
    attributes[46] = "Symptome_Rückenschmerzen";

    attributes[49] = "Periodentag_schwach";
    attributes[50] = "Periodentag_mittel";
    attributes[51] = "Periodentag_stark";
    attributes[52] = "Periodentag_sehr stark";

    attributes[60] = "Aktivität_Kein Training";
    attributes[61] = "Aktivität_Schwimmen";
    attributes[62] = "Aktivität_Yoga";
    attributes[63] = "Aktivität_Radfahren";
    attributes[64] = "Aktivität_Laufen";
    attributes[65] = "Aktivität_Fitness";
    attributes[66] = "Aktivität_Teamsport";
    attributes[67] = "Aktivität_Spazieren";
    attributes[68] = "Aktivität_Tanzen";

    attributes[80] = "Sonstiges_Stress";
    attributes[81] = "Sonstiges_Reisen";
    attributes[82] = "Sonstiges_Alkohol";
    attributes[83] = "Sonstiges_Krankheit";
    attributes[84] = "Sonstiges_Meditation"; 

    attributes[98] = "Schmerzen_Schmerzen";
    attributes[99] = "Temperatur_Temperatur";

    attributes[110] = "Sex und Libido_Kein Sex";
    attributes[111] = "Sex und Libido_Geschützter Sex";
    attributes[112] = "Sex und Libido_Oralsex";
    attributes[113] = "Sex und Libido_Ungeschützer Sex";
    attributes[114] = "Sex und Libido_Analsex";
    attributes[115] = "Sex und Libido_Starke Libido";
    attributes[116] = "Sex und Libido_Neutrale Libido";
    attributes[117] = "Sex und Libido_Geringe Libido";
    attributes[118] = "Sex und Libido_Orgasmus";    

    attributes[130] = "Zyklus_Zykluslänge";
    attributes[131] = "Zyklus_Periodendauer";
    attributes[132] = "Zyklus_Fruchtbarkeitszeitraum";
    attributes[133] = "Zyklus_Datum Eisprung (Schätzwerte)"; 
    attributes[134] = "Zyklus_Erster Tag der letzten Periode"; 

    // Other:
    attributes[900] = "SharedData_ObservationLastMenstrualPeriod";
    attributes[901] = "SharedData_Schmerzlevel";
    attributes[902] = "SharedData_toRowIds";

    // Smart Wearables
    attributes[10000] = "Smart Wearables_Schritte";
    attributes[10001] = "Smart Wearables_Distanz";
    attributes[10002] = "Smart Wearables_Etagen";
    attributes[10003] = "Smart Wearables_Gesamtkalorien";
    attributes[10004] = "Smart Wearables_Verbrannte Kalorien";
    attributes[10005] = "Smart Wearables_Gesamtdauer der Aktivitäten";
    attributes[10006] = "Smart Wearables_Aktive Minuten";
    attributes[10007] = "Smart Wearables_Gesamtschlafzeit";
    attributes[10008] = "Smart Wearables_Zeit im Bett";
    attributes[10009] = "Smart Wearables_REM-Schlaf";
    attributes[10010] = "Smart Wearables_Tiefschlaf";
    attributes[10011] = "Smart Wearables_Schlafenszeit Anfang";
    attributes[10012] = "Smart Wearables_Schlafenszeit Ende";
    attributes[10013] = "Smart Wearables_Schlaf-Effizienz";
    attributes[10014] = "Smart Wearables_Durchschnittliche Herzfrequenz";
    attributes[10015] = "Smart Wearables_Ruhepuls";

    return attributes;
  }


  static attributesWithoutTimeRelevance(){
    return [0,1,2,3,4];// ToDo check if 900 is needed
  }

  static async deleteData(user: string){
    return await db.datasafe.where("appUser").equals(user).delete().then((deleteCount) =>{
      return true
    });
  }

  static async deleteRow(id: number){
    //console.log(id)
    /* @ts-ignore */
    return await db.datasafe.where("id").equals(id).toArray().then((row) =>{
      
      //console.log(row)
      if((typeof row == 'undefined') || (row.length==0)){
        //console.log('row not found id:'+id)
        return true;
      }else{
        //console.log(row)
        if(typeof row[0].serverId != 'undefined')
        if(row[0].serverId > 0){
          return SystemToDo.addToToDo(row[0].appUser,'deleteRowOnServer',row[0].serverId).then(() => {
            return db.datasafe.where("id").equals(id).delete().then((deleteCount) =>{
              //console.log(deleteCount)
              return true
            })
          })
        }else{
          return db.datasafe.where("id").equals(id).delete().then((deleteCount) =>{
            //console.log(deleteCount)
            return true
          })
        }
        
      }
      return true
      
    });
  }

  static async  deleteToServerIds(user: string,deletedServerIds: any){
    for(var i=0; i< deletedServerIds.length; i++){ 
      let delserverId = deletedServerIds[i]
      //console.log(delserverId)
      await db.datasafe.where({appUser: user, serverId: delserverId}).delete();
    }

  }

  static async updateServerIdTStoId(id: number, serverId: number, serverIdUpdateTS: number){
    return await db.datasafe.update(id, {serverId: serverId, serverIdUpdateTS: serverIdUpdateTS})
  }

  static async getAllIds(ids: any){
    return await db.datasafe.bulkGet(ids);
  }

  static async insertOrUpdate(user: string, AttrObj: Object){

    /* @ts-ignore */
   let attr = [];
   Object.keys(AttrObj).forEach(function(v){
     attr.push(parseInt(v));
   });
   //console.log(attr)
   let Now = new Date();

    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      //console.log(AttrObj);
      let handled = [];
      
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let iStr = i.toString();
        let resAttribute = (row.attribute);
        let resValue =  row.value;
        let resDTto = row.valueTSto;
        let resId = row.id;
        /* @ts-ignore */
        //console.log(attr)
        /* @ts-ignore */
        if(attr.includes( resAttribute )){
          //console.log('in')
          /* @ts-ignore */
          if((resDTto == 0) && (resValue != AttrObj[resAttribute])){
            // set old inactive
            /* @ts-ignore */
            db.datasafe.update(resId, {valueTSto: (Now.getTime()-1)})
            if(row.serverId != 0){
              SystemToDo.addToToDo(user,'updateRowOnServer',resId)
            }

            // insert new
            db.datasafe.add({
              appUser: user,
              /* @ts-ignore */
              attribute: parseInt(resAttribute),
              /* @ts-ignore */
              value: AttrObj[resAttribute],
              valueTSfrom: Now.getTime(),
              valueTSto: 0,
              valueTSinsert: Now.getTime(),
              serverId: 0,
              serverIdUpdateTS: 0,
            }).then((id) => {
              SystemToDo.addToToDo(user,'insertRowOnServer',id)
            })

            handled.push(resAttribute);
          }

          /* @ts-ignore */
          if((resDTto == 0) && (resValue == AttrObj[resAttribute])){
            //console.log(resAttribute);
            handled.push(resAttribute);
          }
          
        }
      }

      for(var i =0; i < attr.length; i++){
        /* @ts-ignore */
        if(!handled.includes(attr[i])){
          //console.log(handled);
          // insert
          db.datasafe.add({
            appUser: user,
            /* @ts-ignore */
            attribute: parseInt(attr[i]),
            /* @ts-ignore */
            value: AttrObj[attr[i]],
            valueTSfrom: Now.getTime(),
            valueTSto: 0,
            valueTSinsert: Now.getTime(),
            serverId: 0,
            serverIdUpdateTS: 0,
          }).then((id) => {
            SystemToDo.addToToDo(user,'insertRowOnServer',id)
          })
        }
      }
    }).then( () => { return 'finished'} );
  }


  static async insertOrUpdateSingleRowToDate(user: string, AttrObj: Object, ValueDate: Date){
    //console.log(AttrObj)
    let TSfromDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),0,0,0);
    let tsFrom = TSfromDate.getTime();

    let TSToDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),23,59,59);
    let tsTo = TSToDate.getTime();

    /* @ts-ignore */
    let attr = [];
    Object.keys(AttrObj).forEach(function(v){
      attr.push(parseInt(v));
    });
    //console.log(attr)
    let Now = new Date();

    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      //console.log(AttrObj);
      let handled = [];
      
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let iStr = i.toString();
        let resAttribute = (row.attribute);
        let resValue =  row.value;
        let resDTto = row.valueTSto;
        let resId = row.id;
        /* @ts-ignore */
        //console.log(attr)
        /* @ts-ignore */
        if(attr.includes( resAttribute )
        && (row.valueTSfrom >= tsFrom)
        && (row.valueTSfrom <= tsTo)){
          //console.log('in')

          // for import if csv contains older text to day ToDo: maybe other update strategy 
          //if (row.valueTSfrom <= ValueDate.getTime()){
            //console.log('why here Time')
          /* @ts-ignore */
            if((resDTto == 0) && (resValue != AttrObj[resAttribute])){
              // set old inactive
              /* @ts-ignore */

              // insert new
              db.datasafe.update(resId, {
                appUser: user,
                /* @ts-ignore */
                attribute: parseInt(resAttribute),
                /* @ts-ignore */
                value: AttrObj[resAttribute],
                //valueTSfrom: ValueDate.getTime(),
                valueTSto: 0,
                valueTSinsert: Now.getTime(),
              })
              if(row.serverId != 0){
                SystemToDo.addToToDo(user,'updateRowOnServer',resId)
              }
            }
            handled.push(resAttribute);
          //}

          /* @ts-ignore */
          if((resDTto == 0) && (resValue == AttrObj[resAttribute])){
            //console.log(resAttribute);
            handled.push(resAttribute);
          }
          
        }
      }
      
      for(var i =0; i < attr.length; i++){
        /* @ts-ignore */
        if(!handled.includes(attr[i])){
          //console.log(handled);
          // insert
          db.datasafe.add({
            appUser: user,
            /* @ts-ignore */
            attribute: parseInt(attr[i]),
            /* @ts-ignore */
            value: AttrObj[attr[i]],
            valueTSfrom: ValueDate.getTime(),
            valueTSto: 0,
            valueTSinsert: Now.getTime(),
            serverId: 0,
            serverIdUpdateTS: 0,
          }).then((id) => {
            SystemToDo.addToToDo(user,'insertRowOnServer',id)
          })
        }
      }
    }).then( () => { return 'finished'} );


  }

  static async insertOrUpdateSingleRowToDateWithMultiple(Rows: Array<{user: string, AttrObj: Object, ValueDate: Date}>){
    if(Rows.length> 0){
      
      let user = Rows[0].user;
      return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
        db.transaction("rw!", db.datasafe, db.systemToDo, () => {
          for(var r=0; r <Rows.length; r++){
            let Row = Rows[r];

            let ValueDate = Row.ValueDate;
            let AttrObj = Row.AttrObj;

            let TSfromDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),0,0,0);
            let tsFrom = TSfromDate.getTime();
        
            let TSToDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),23,59,59);
            let tsTo = TSToDate.getTime();
        
            /* @ts-ignore */
            let attr = [];
            Object.keys(AttrObj).forEach(function(v){
              attr.push(parseInt(v));
            });
            //console.log(attr)
            let Now = new Date();

            //this.insertOrUpdateSingleRowToDate(Row.user, Row.AttrObj, Row.ValueDate);
            let handled = [];
      
            for(var i =0; i < res.length; i++){
              let row = res[i];
              let iStr = i.toString();
              let resAttribute = (row.attribute);
              let resValue =  row.value;
              let resDTto = row.valueTSto;
              let resId = row.id;
              /* @ts-ignore */
              //console.log(attr)
              /* @ts-ignore */
              if(attr.includes( resAttribute )
              && (row.valueTSfrom >= tsFrom)
              && (row.valueTSfrom <= tsTo)){
                //console.log('in')

                // for import if csv contains older text to day ToDo: maybe other update strategy 
                //if (row.valueTSfrom <= ValueDate.getTime()){
                  //console.log('why here Time')
                /* @ts-ignore */
                  if((resDTto == 0) && (resValue != AttrObj[resAttribute])){
                    // set old inactive
                    /* @ts-ignore */

                    // insert new
                    db.datasafe.update(resId, {
                      appUser: user,
                      /* @ts-ignore */
                      attribute: parseInt(resAttribute),
                      /* @ts-ignore */
                      value: AttrObj[resAttribute],
                      //valueTSfrom: ValueDate.getTime(),
                      valueTSto: 0,
                      valueTSinsert: Now.getTime(),
                    })
                    if(row.serverId != 0){
                      SystemToDo.addToToDo(user,'updateRowOnServer',resId)
                    }
                  }
                  handled.push(resAttribute);
                //}

                /* @ts-ignore */
                if((resDTto == 0) && (resValue == AttrObj[resAttribute])){
                  //console.log(resAttribute);
                  handled.push(resAttribute);
                }
                
              }
            }
              
            for(var i =0; i < attr.length; i++){
              /* @ts-ignore */
              if(!handled.includes(attr[i])){
                //console.log(handled);
                // insert
                db.datasafe.add({
                  appUser: user,
                  /* @ts-ignore */
                  attribute: parseInt(attr[i]),
                  /* @ts-ignore */
                  value: AttrObj[attr[i]],
                  valueTSfrom: ValueDate.getTime(),
                  valueTSto: 0,
                  valueTSinsert: Now.getTime(),
                  serverId: 0,
                  serverIdUpdateTS: 0,
                }).then((id) => {
                  SystemToDo.addToToDo(user,'insertRowOnServer',id)
                })
              }
            }
          }
        })
        return true
      })  
    }
    return false
  }

  static async insertOrUpdateCompleteDataRow(user: string, NewDataRows: any){
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      //console.log(AttrObj);
      let handled = [];
      let DateSortedLocal = {};
      let NewDataRowsSorted = {}
      
      for(var i =0; i < res.length; i++){
        let row = res[i];
        DateSortedLocal = DataSafe.addToMySortedData(DateSortedLocal,row);
      }
      //console.log(NewDataRows);
      for(var d=0; d < NewDataRows.length; d++){
        let DataRow = NewDataRows[d];
        NewDataRowsSorted = DataSafe.addToMySortedData(NewDataRowsSorted,DataRow);
      }

      let RelevantDateKeys = Object.keys(NewDataRowsSorted);
      //console.log(DateSortedLocal);
      for ( var k = 0; k < RelevantDateKeys.length; k++){
        let insepctDateKey = RelevantDateKeys[k];

        /* @ts-ignore */
        let doafter = DataSafe.doInserUpdateWork(DateSortedLocal,NewDataRowsSorted[insepctDateKey],insepctDateKey);

        
      }
    })
  }
  
  static doInserUpdateWork(DateSortedLocal: any, NewDataToDateKey: any, DateKey: any){
    let errorOutput=true;
    let NewDayAttributes = Object.keys(NewDataToDateKey);

    // Does Client has data to this day?
    /* @ts-ignore */
    if(typeof DateSortedLocal[DateKey] == 'undefined'){
      // client no data to this day
      //console.log('insert all')
      // 'completeDayInsert';
      for(var k=0; k<NewDayAttributes.length;k++){
       let newDayAttribute = NewDayAttributes[k];
        /* @ts-ignore */
        let NewAttributeEntryTSs = Object.keys(NewDataToDateKey[newDayAttribute]);
       //console.log(NewDataToDateKey[newDayAttribute]);
        for(var a=0; a<NewAttributeEntryTSs.length;a++){
          let rowNewDayAttrTS = NewAttributeEntryTSs[a];
          let rowNewDayAttr = NewDataToDateKey[newDayAttribute][rowNewDayAttrTS];
          db.datasafe.add({
            appUser: DataSafe.valToKeyCheck(rowNewDayAttr.appUser,'appUser'),
            /* @ts-ignore */
            attribute: DataSafe.valToKeyCheck(parseInt(rowNewDayAttr.attribute),'attribute'),
            /* @ts-ignore */
            value: DataSafe.valToKeyCheck(rowNewDayAttr.value,'value'),
            valueTSfrom: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSfrom,'valueTSfrom'),
            valueTSto: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSto,'valueTSto'),
            valueTSinsert: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSinsert,'valueTSinsert'),
            serverId: DataSafe.valToKeyCheck(rowNewDayAttr.serverId,'serverId'),
            serverIdUpdateTS: DataSafe.valToKeyCheck(rowNewDayAttr.serverIdUpdateTS,'serverIdUpdateTS'),
          }).then(result => {
            // Success
            }).catch('ConstraintError', e => {
                // Failed with ConstraintError
                if(errorOutput)
                  console.error ("1 Constraint error: " + e.message);
            }).catch(Error, e => {
                // Any other error derived from standard Error
                if(errorOutput)
                  console.error ("1 Error: " + e.message);
            }).catch(e => {
                // Other error such as a string was thrown
                if(errorOutput)
                console.error (e);
            });
        }

      }
      return true;
    }

    // client has data to this day
    // for all Attribute-numbers to this day:
    for(var k=0; k<NewDayAttributes.length;k++){
      let inspectAttribute = NewDayAttributes[k];
      /* @ts-ignore */
      if(typeof DateSortedLocal[DateKey][inspectAttribute] == 'undefined'){
        // client has not this attribute on this day
        //console.log('completeAttributeInsert');
        // 'completeAttributeInsert';
        let NewAttributeEntryTSs = Object.keys(NewDataToDateKey[inspectAttribute]);
        for(var a=0; a<NewAttributeEntryTSs.length;a++){
          let rowNewDayAttr = NewDataToDateKey[inspectAttribute][NewAttributeEntryTSs[a]];
          db.datasafe.add({
            appUser: DataSafe.valToKeyCheck(rowNewDayAttr.appUser,'appUser'),
            /* @ts-ignore */
            attribute: DataSafe.valToKeyCheck(parseInt(rowNewDayAttr.attribute),'attribute'),
            /* @ts-ignore */
            value: DataSafe.valToKeyCheck(rowNewDayAttr.value,'value'),
            valueTSfrom: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSfrom,'valueTSfrom'),
            valueTSto: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSto,'valueTSto'),
            valueTSinsert: DataSafe.valToKeyCheck(rowNewDayAttr.valueTSinsert,'valueTSinsert'),
            serverId: DataSafe.valToKeyCheck(rowNewDayAttr.serverId,'serverId'),
            serverIdUpdateTS: DataSafe.valToKeyCheck(rowNewDayAttr.serverIdUpdateTS,'serverIdUpdateTS'),
          }).then(result => {
            // Success
            }).catch('onstraintError', e => {
              // Failed with ConstraintError
              if(errorOutput)
                console.error ("2 Constraint error: " + e.message);
          }).catch(Error, e => {
              // Any other error derived from standard Error
              if(errorOutput)
                console.error ("2 Error: " + e.message);
          }).catch(e => {
              // Other error such as a string was thrown
              if(errorOutput)
              console.error (e);
          });
        }

        
        // client has this attribute on this day
      }else{
        //console.log('else completeAttributeInsert');
        let ExistingAttributeEntryTSs = Object.keys(DateSortedLocal[DateKey][inspectAttribute]);
        /* @ts-ignore */
        let NewAttributeEntryTSs = Object.keys(NewDataToDateKey[inspectAttribute]);

        // all TS to this Attribute (on Server and on client)
        let AttributeTSs = ExistingAttributeEntryTSs.concat(NewAttributeEntryTSs);
        AttributeTSs = Array.from(new Set(AttributeTSs));
        AttributeTSs.sort();
        //console.log(AttributeTSs);
        let lastKeyNb = (AttributeTSs.length-1);
        let lastNfinal = AttributeTSs[lastKeyNb];

        let RowBefore = {};
        let RowAfter = {};

        // for all TS to this Attribute (on Server and on client)
        for(var a=0; a<AttributeTSs.length; a++){
          let inspectTS = AttributeTSs[a];
          /* @ts-ignore */
          let terminateTS = inspectTS-1;
          let inExisting = ExistingAttributeEntryTSs.includes(inspectTS);
          let inNew = NewAttributeEntryTSs.includes(inspectTS);

          // let last TS win...
          if(a<lastKeyNb-1){
            let inspectAfterTS = AttributeTSs[a+1];

            // the attribute ts is on both sides
            if((inExisting == true) && (inNew == true)){
              // update old to inspectAfterTS
              let Existing = DateSortedLocal[DateKey][inspectAttribute][inspectTS];
              /* @ts-ignore */
              let New = NewDataToDateKey[inspectAttribute][inspectTS];

              // possible that some earlier updaten didn't work - check if both are same but only serverId is local missing
              let compared = DataSafe.compareNearlySameRows(Existing, New);
              if(compared === false){
                //console.log('not nearly same')
              

                if(Existing.valueTSto != terminateTS){
                  db.datasafe.update(Existing.id, {valueTSto: terminateTS}).then(result => {
                      // Success
                    }).catch('ConstraintError', e => {
                      // Failed with ConstraintError
                      if(errorOutput)
                        console.error ("3 Constraint error: " + e.message);
                  }).catch(Error, e => {
                      // Any other error derived from standard Error
                      if(errorOutput)
                        console.error ("3 Error: " + e.message);
                  }).catch(e => {
                      // Other error such as a string was thrown
                      if(errorOutput)
                      console.error (e);
                  });
                }
                
                // insertNew with inspectAfterTS
                db.datasafe.add({
                  appUser: DataSafe.valToKeyCheck(New.appUser,'appUser'),
                  /* @ts-ignore */
                  attribute: DataSafe.valToKeyCheck(parseInt(New.attribute),'attribute'),
                  /* @ts-ignore */
                  value: DataSafe.valToKeyCheck(New.value,'value'),
                  valueTSfrom: DataSafe.valToKeyCheck(New.valueTSfrom,'valueTSfrom'),
                  valueTSto: DataSafe.valToKeyCheck(terminateTS,'valueTSto'),
                  valueTSinsert: DataSafe.valToKeyCheck(New.valueTSinsert,'valueTSinsert'),
                  serverId: DataSafe.valToKeyCheck(New.serverId,'serverId'),
                  serverIdUpdateTS: DataSafe.valToKeyCheck(New.serverIdUpdateTS,'serverIdUpdateTS'),
                }).then(result => {
                    // Success
                  }).catch('ConstraintError', e => {
                    // Failed with ConstraintError
                    if(errorOutput)
                      console.error ("4 Constraint error: " + e.message);
                }).catch(Error, e => {
                    // Any other error derived from standard Error
                    if(errorOutput)
                      console.error ("4 Error: " + e.message);
                }).catch(e => {
                    // Other error such as a string was thrown
                    if(errorOutput)
                    console.error (e);
                });
              }
              RowBefore = New;
            }else{
              // the attribute ts is only on client:
              if(inExisting == true){
                // do nothing
                //console.log('do nothing ');
                let Existing = DateSortedLocal[DateKey][inspectAttribute][inspectTS];
                let New = NewDataToDateKey[inspectAttribute][inspectTS];
                //console.log(Existing);
                //console.log(New);

                RowBefore = DateSortedLocal[DateKey][inspectAttribute][inspectTS];
              }
              // the attribute ts is only on server:
              if(inNew == true){
                // do terminated insert 
                console.log('inNew ');
                /* @ts-ignore */
                let New2 = NewDataToDateKey[inspectAttribute][inspectTS];
                let StartTS = New2.valueTSfrom;
                if(a>0){
                  /* @ts-ignore */
                  let BeforeEndTS = RowBefore.valueTSto;
                  if(BeforeEndTS>StartTS)StartTS=BeforeEndTS+1;
                }
                /* @ts-ignore */
                let New = NewDataToDateKey[inspectAttribute][inspectTS];
                db.datasafe.add({
                  appUser: DataSafe.valToKeyCheck(New2.appUser,'appUser'),
                  /* @ts-ignore */
                  attribute: DataSafe.valToKeyCheck(parseInt(New2.attribute),'attribute'),
                  /* @ts-ignore */
                  value: DataSafe.valToKeyCheck(New2.value,'value'),
                  valueTSfrom: DataSafe.valToKeyCheck(StartTS,'valueTSfrom'),
                  valueTSto: DataSafe.valToKeyCheck(terminateTS,'valueTSto'),
                  valueTSinsert: DataSafe.valToKeyCheck(New2.valueTSinsert,'valueTSinsert'),
                  serverId: DataSafe.valToKeyCheck(New2.serverId,'serverId'),
                  serverIdUpdateTS: DataSafe.valToKeyCheck(New2.serverIdUpdateTS,'serverIdUpdateTS'),
                }).then(result => {
                    // Success
                  }).catch('ConstraintError', e => {
                    // Failed with ConstraintError
                    if(errorOutput)
                      console.error ("5 Constraint error: " + e.message);
                }).catch(Error, e => {
                    // Any other error derived from standard Error
                    if(errorOutput)
                      console.error ("5 Error: " + e.message);
                }).catch(e => {
                    // Other error such as a string was thrown
                    if(errorOutput)
                    console.error (e);
                });
                RowBefore = New2;
              }
            }
          }else{
            let isFinalUpdated = false
            if((inNew == true) && (inExisting == true)){
              let myExisting = DateSortedLocal[DateKey][inspectAttribute][inspectTS];
              //console.log(myExisting);
              let myNew = NewDataToDateKey[inspectAttribute][inspectTS];
              //console.log(myNew)
              isFinalUpdated = DataSafe.compareNearlySameRows(myExisting, myNew)
            }
            if(isFinalUpdated===false){
              // set last
              if(inNew == true){
                //console.log('last inNew ');
                /* @ts-ignore */
                let New3 = NewDataToDateKey[inspectAttribute][inspectTS];
                db.datasafe.add({
                  appUser: DataSafe.valToKeyCheck(New3.appUser,'appUser'),
                  /* @ts-ignore */
                  attribute: DataSafe.valToKeyCheck(parseInt(New3.attribute),'attribute'),
                  /* @ts-ignore */
                  value: DataSafe.valToKeyCheck(New3.value,'value'),
                  valueTSfrom: DataSafe.valToKeyCheck(New3.valueTSfrom,'valueTSfrom'),
                  valueTSto: DataSafe.valToKeyCheck(New3.valueTSto,'valueTSto'),
                  valueTSinsert: DataSafe.valToKeyCheck(New3.valueTSinsert,'valueTSinsert'),
                  serverId: DataSafe.valToKeyCheck(New3.serverId,'serverId'),
                  serverIdUpdateTS: DataSafe.valToKeyCheck(New3.serverIdUpdateTS,'serverIdUpdateTS'),
                }).then(result => {
                    // Success
                  }).catch('ConstraintError', e => {
                    // Failed with ConstraintError
                    if(errorOutput)
                      console.error ("6 Constraint error: " + e.message);
                }).catch(Error, e => {
                    // Any other error derived from standard Error
                    if(errorOutput)
                      console.error ("6 Error: " + e.message);
                }).catch(e => {
                    // Other error such as a string was thrown
                    if(errorOutput)
                    console.error (e);
                });
              }else{
                //console.log('last not inNew '); //do nothing
              }
            }
          }
        }

      }
    }
  }

  static compareNearlySameRows(Existing: any, New: any){
     // possible that some earlier update didn't work - check if both are same but only serverId is local missing
     if(((Existing.valueTSfrom == New.valueTSfrom)
     &&  (Existing.valueTSinsert == New.valueTSinsert)
     &&  (Existing.serverId == 0))
     || (Existing.serverId == New.serverId)
      
        ){
      db.datasafe.update(Existing.id, { serverId: DataSafe.valToKeyCheck(New.serverId,'serverId'),
                                        serverIdUpdateTS: DataSafe.valToKeyCheck(New.serverIdUpdateTS,'serverIdUpdateTS'),
                                        value: DataSafe.valToKeyCheck(New.value,'value'),
                                        valueTSto: DataSafe.valToKeyCheck(New.valueTSto,'valueTSto'),
                                        valueTSinsert: DataSafe.valToKeyCheck(New.valueTSinsert,'valueTSinsert'),
                                      }).then(result => {
                                        // Success
                                    }).catch('ConstraintError', e => {
                                        // Failed with ConstraintError
                                        console.error ("7 Constraint error: " + e.message);
                                    }).catch(Error, e => {
                                        // Any other error derived from standard Error
                                        console.error ("7 Error: " + e.message);
                                    }).catch(e => {
                                        // Other error such as a string was thrown
                                        console.error (e);
                                    });
      //console.log('found in nearly same')
      return true;
     }
     if((Existing.valueTSfrom == New.valueTSfrom)
        && (Existing.value == New.value)
        && (parseInt(Existing.attribute) == parseInt(New.attribute))
        && (Existing.serverId != New.serverId)
        && (Existing.serverId != 0)
        && (New.serverId != 0)){
          //console.log(Existing)
          //console.log(New)
          if(parseInt(Existing.serverId) > parseInt(New.serverId)){
            db.datasafe.update(Existing.id, { serverId: DataSafe.valToKeyCheck(New.serverId,'serverId'),
                                        serverIdUpdateTS: DataSafe.valToKeyCheck(New.serverIdUpdateTS,'serverIdUpdateTS'),
                                        value: DataSafe.valToKeyCheck(New.value,'value'),
                                        valueTSto: DataSafe.valToKeyCheck(New.valueTSto,'valueTSto'),
                                        valueTSinsert: DataSafe.valToKeyCheck(New.valueTSinsert,'valueTSinsert'),
                                      }).then(result => {
                                        // Success
                                    }).catch('ConstraintError', e => {
                                        // Failed with ConstraintError
                                        console.error ("7 Constraint error: " + e.message);
                                    }).catch(Error, e => {
                                        // Any other error derived from standard Error
                                        console.error ("7 Error: " + e.message);
                                    }).catch(e => {
                                        // Other error such as a string was thrown
                                        console.error (e);
                                    });
            SystemToDo.addToToDo(Existing.appUser,'deleteRowOnServer',Existing.serverId)
          }else{
        // double rows on server - delete one on server
          let deleteServerId = New.serverId;
          //if(Existing.serverId > New.serverId)deleteServerId = New.serverId;
            SystemToDo.addToToDo(Existing.appUser,'deleteRowOnServer', New.serverId)
          }
          return true;
     }
     return false;
  }

  static addToMySortedData(DateSortedLocal: any,row: any){
    let ValueDate = new Date();
    ValueDate.setTime(row.valueTSfrom);
    let DateKey = ValueDate.getFullYear()+''+DataSafe.leadingZero(ValueDate.getMonth())+''+DataSafe.leadingZero(ValueDate.getDate());
    /* @ts-ignore */
    if(typeof DateSortedLocal[DateKey] == 'undefined')DateSortedLocal[DateKey]={};
    /* @ts-ignore */
    if(typeof DateSortedLocal[DateKey][row.attribute] == 'undefined')DateSortedLocal[DateKey][row.attribute]={};
    /* @ts-ignore */
    if(typeof DateSortedLocal[DateKey][row.attribute][row.valueTSfrom] == 'undefined')DateSortedLocal[DateKey][row.attribute][row.valueTSfrom]={};
    /* @ts-ignore */
    DateSortedLocal[DateKey][row.attribute][row.valueTSfrom] = row;

    return DateSortedLocal;
  }


  static async insertOrUpdateToDate(user: string, AttrObj: Object, ValueDate: Date){

    let Now = new Date();

    // if doublesafe today after waiting (without other page) the DT there will not be changed
    if(ValueDate.getFullYear()+''+DataSafe.leadingZero(ValueDate.getMonth())+''+DataSafe.leadingZero(ValueDate.getDate())   == Now.getFullYear()+''+DataSafe.leadingZero(Now.getMonth())+''+DataSafe.leadingZero(Now.getDate())){
      ValueDate = Now;
    }


    let TSfromDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),0,0,0);
    let tsFrom = TSfromDate.getTime();

    let TSToDate = new Date(ValueDate.getFullYear(), ValueDate.getMonth(), ValueDate.getDate(),23,59,59);
    let tsTo = TSToDate.getTime();

    
    /* @ts-ignore */
    let attr = [];
    Object.keys(AttrObj).forEach(function(v){
      attr.push(parseInt(v));
    });
    //console.log(attr)
   

    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      //console.log(AttrObj);
      let handled = [];
      let toInspect = {};

      for(var i =0; i < res.length; i++){
        let row = res[i];
        let iStr = i.toString();
        let resAttribute = (row.attribute);
        let resValue =  row.value;
        let resDTto = row.valueTSto;
        let resId = row.id;

        /* @ts-ignore */
        if( (row.valueTSto > 0) 
        /* @ts-ignore */
        || (!attr.includes( row.attribute )) 
        || (row.valueTSfrom < tsFrom) 
        || (row.valueTSfrom > tsTo)
        ){
          continue;
        }else{
          /* @ts-ignore */
          if(typeof toInspect[row.attribute] == 'undefined')toInspect[row.attribute] = {};
          /* @ts-ignore */
          if(typeof toInspect[row.attribute][row.valueTSfrom] == 'undefined')toInspect[row.attribute][row.valueTSfrom] = [];
          /* @ts-ignore */
          toInspect[row.attribute][row.valueTSfrom].push(row);
        }
      }
      
      let insertFrom = 0;
      let existingInsertTo = 0;
      let isOldDay = false;
      // set Times
      if(Now > TSToDate){
        // insert value days after - no timecontrol 
        insertFrom = tsTo;
        existingInsertTo = tsTo;
        isOldDay = true;
      }else{
        insertFrom = ValueDate.getTime();
        existingInsertTo = (ValueDate.getTime()-1);
      }

      let existingAttributes = Object.keys(toInspect);

      for(var n=0; n < attr.length; n++){
        /* @ts-ignore */
        let newAttributeNb = attr[n];

        if(existingAttributes.includes(newAttributeNb.toString())  === false
        ){
          // -> insert
          // insert new
          //console.log('insert complete')
          db.datasafe.add({
            appUser: user,
            /* @ts-ignore */
            attribute: parseInt(newAttributeNb),
            /* @ts-ignore */
            value: AttrObj[newAttributeNb],
            valueTSfrom: insertFrom,
            valueTSto: 0,
            valueTSinsert: Now.getTime(),
            serverId: 0,
            serverIdUpdateTS: 0,
          }).then((id) => {
            SystemToDo.addToToDo(user,'insertRowOnServer',id)
          })

        }else{
          // compare
          /* @ts-ignore */
          let existingTimesToAttribute = Object.keys(toInspect[newAttributeNb]);
          existingTimesToAttribute.sort();

          let isNewAdded = false;
          /* @ts-ignore */
          for(var t=0; t < existingTimesToAttribute.length; t++){
            /* @ts-ignore */
            
            let existingRows = toInspect[newAttributeNb][existingTimesToAttribute[t]];
            let existingInnerKeys = Object.keys(existingRows);
            
            for(var e = 0; e < existingInnerKeys.length;e++ ){
              //let existingRow = existingInnereys[e];
              /* @ts-ignore */
              let existingRow = toInspect[newAttributeNb][existingTimesToAttribute[t]][existingInnerKeys[e]];
              //console.log(existingRow);
              // terminate all old rows if they are not
              
              if(existingRow.valueTSto == 0){
                // ToDo Compare existing same rows - maybe one is on server and other not?
              /* @ts-ignore */
                if (existingRow.value != AttrObj[newAttributeNb]){
                  if(insertFrom != existingRow.valueTSfrom){
                    //console.log('up + insert')
                    db.datasafe.update(existingRow.id, {valueTSto: existingInsertTo})
                    if(existingRow.serverId != 0){
                      SystemToDo.addToToDo(user,'updateRowOnServer',existingRow.id)
                    }
                    db.datasafe.add({
                      appUser: user,
                      /* @ts-ignore */
                      attribute: parseInt(newAttributeNb),
                      /* @ts-ignore */
                      value: AttrObj[newAttributeNb],
                      valueTSfrom: insertFrom,
                      valueTSto: 0,
                      valueTSinsert: Now.getTime(),
                      serverId: 0,
                      serverIdUpdateTS: 0,
                    }).then((id) => {
                      SystemToDo.addToToDo(user,'insertRowOnServer',id)
                    })
                    isNewAdded = true;
                  }else{
                    //console.log('only update')
                    /* @ts-ignore */
                    db.datasafe.update(existingRow.id, {  value: AttrObj[newAttributeNb],
                                                          valueTSfrom: insertFrom, 
                                                          valueTSto: 0, 
                                                          valueTSinsert: Now.getTime(),
                                                        })
                    if(existingRow.serverId != 0){
                      SystemToDo.addToToDo(user,'updateRowOnServer',existingRow.id)
                    }
                    isNewAdded = true;
                  }
                }else{
                  // value is same and tsto is open
                  isNewAdded = true;
                }
              }else{
                // has terminated TSto
                isNewAdded = true;
              }
            }
            
          }
          if(isNewAdded === false){
            //console.log('insert new')
            // insert new
            db.datasafe.add({
              appUser: user,
              /* @ts-ignore */
              attribute: parseInt(newAttributeNb),
              /* @ts-ignore */
              value: AttrObj[newAttributeNb],
              valueTSfrom: insertFrom,
              valueTSto: 0,
              valueTSinsert: Now.getTime(),
              serverId: 0,
              serverIdUpdateTS: 0,
            }).then((id) => {
              SystemToDo.addToToDo(user,'insertRowOnServer',id)
            })
          }
        }
      }
    }).then( () => { return 'finished'} );
  }


  static async insertOrUpdateToObjectName(user: string, attrNb: number, valueObj: Object, nameKey:string ){
    //console.log(attr)
    let Now = new Date();

    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let rowId = row.id;
        if(row.attribute == attrNb){
          let dataRow = JSON.parse(row.value);
          if(typeof dataRow[nameKey] != 'undefined'){
            /* @ts-ignore */
            if(dataRow[nameKey] == valueObj[nameKey]){
              //update
              //console.log('update')
              /* @ts-ignore */
              db.datasafe.update(rowId, {value:JSON.stringify(valueObj), valueTSfrom: (Now.getTime())})
              if(row.serverId != 0){
                SystemToDo.addToToDo(user,'updateRowOnServer',rowId)
              }
              return 'updated';
            }
          }
        }
      }

      // if here, nothing is found - do insert
      db.datasafe.add({
        appUser: user,
        /* @ts-ignore */
        attribute: attrNb,
        /* @ts-ignore */
        value: JSON.stringify(valueObj),
        valueTSfrom: Now.getTime(),
        valueTSto: 0,
        valueTSinsert: Now.getTime(),
        serverId: 0,
        serverIdUpdateTS: 0,
      }).then((id) => {
        SystemToDo.addToToDo(user,'insertRowOnServer',id)
      })
      return 'inserted'

    })
  }

  static async getLastValuesToAttributes(user: string, attributeNumbers: Array<number> ){
    //console.log(user);
    //console.log(attributeNumbers);
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let ret = new Map;
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let iStr = i.toString();
        let resAttribute = (row.attribute);
        let resValue =  row.value;
        let resDTfrom = row.valueTSfrom;
        let resDTto = row.valueTSto;
        let resDTinsert = row.valueTSinsert;
        let resId = row.id;

        if(attributeNumbers.includes( resAttribute )){
          if(resDTto == 0){
            ret.set(resAttribute,row);
          }
        }
      }
      return ret;
    });
  }

  static async getAllValuesToAttributeNbs(user: string, attributeNumbers: Array<number>, JSONparse: boolean){
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let ret = [];
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let resAttribute = (row.attribute);
        if(attributeNumbers.includes( resAttribute )){
          if(JSONparse === true){
            row.value = JSON.parse(row.value);
          }
          ret.push(row)
        }
      }
      return ret;
    })
  }


  static async getAllValuesWithAttributeNames(user: string,datefunction: String){
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let myAttributesDe = DataSafe.myAttributesDe();
      let myAttributes = DataSafe.myAttributes();
      let ret = [];
      for(var i =0; i < res.length; i++){
        let row = res[i];
        /* @ts-ignore */
        row["attribute_eng"] = myAttributes[row.attribute];
        /* @ts-ignore */
        row["attribute_de"] = myAttributesDe[row.attribute];
        /* @ts-ignore */
        row["valuefrom"] = DataSafe.ifDateOrNothing(row["valueTSfrom"],datefunction);
        /* @ts-ignore */
        row["valueto"] = DataSafe.ifDateOrNothing(row["valueTSto"],datefunction);
        /* @ts-ignore */
        row["valueinsert"] = DataSafe.ifDateOrNothing(row["valueTSinsert"],datefunction);
        ret.push(row);
      }
      return ret;
    })
  }

  static async getDayValuesToAttributesWithNamesTimeRange(user: string, attributeNumbers: Array<number>, From: Date, To: Date ){
   
    //console.log(toRaw(ShowDate))
    let TSfromDate = From;
    let tsFrom = TSfromDate.getTime();

    let TSToDate = To;
    let tsTo = TSToDate.getTime();
    
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let myAttributesDe = DataSafe.myAttributesDe();
      let myAttributes = DataSafe.myAttributes();
      let attributesWithoutTimeRelevance = DataSafe.attributesWithoutTimeRelevance();
      let datefunction = 'dateToString';
      let ret = [];
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let resAttribute = (row.attribute);
        //console.log(row)
        /* @ts-ignore */
        if((attributeNumbers.includes( parseInt(resAttribute) )) 
          && (((row.valueTSfrom >= tsFrom)
              && (row.valueTSfrom <= tsTo))
              /* @ts-ignore */
              || (attributesWithoutTimeRelevance.includes( parseInt(resAttribute)))
          )){
            let row = res[i];
            //console.log(row)
            /* @ts-ignore */
            row["attribute_eng"] = myAttributes[row.attribute];
            /* @ts-ignore */
            row["attribute_de"] = myAttributesDe[row.attribute];
            /* @ts-ignore */
            row["valuefrom"] = DataSafe.ifDateOrNothing(row["valueTSfrom"],datefunction);
            /* @ts-ignore */
            row["valueto"] = DataSafe.ifDateOrNothing(row["valueTSto"],datefunction);
            /* @ts-ignore */
            row["valueinsert"] = DataSafe.ifDateOrNothing(row["valueTSinsert"],datefunction);
            ret.push(row);
        }
      }
      return ret;
    });
  }


  static ifDateOrNothing(TS: number,datefunction: String){
    if(TS>0){
      switch(datefunction){
        case 'dateToString':
          let theDate = new Date(TS);
          return theDate.toLocaleString();
          break;
        case 'noOtherDate':
          return '';
          break;
        default:
          return new Date(TS);
      }
      
    }else{
      return null;
    }
  }


  static async getDayValuesToAttributes(user: string, attributeNumbers: Array<number>, ShowDate: Date ){
    //console.log(toRaw(ShowDate))
    if(!(ShowDate instanceof Date)){
      //console.log('is not Date');
      /* @ts-ignore */
      if(typeof ShowDate._value == 'object'){
        //console.log('is object');
        /* @ts-ignore */
        if(ShowDate._value instanceof Date){
          //console.log('is Date');
          /* @ts-ignore */
          ShowDate = ShowDate._value;
        }
      }
      
    }
    //console.log(toRaw(ShowDate))
    let TSfromDate = new Date(ShowDate.getFullYear(), ShowDate.getMonth(), ShowDate.getDate(),0,0,0);
    let tsFrom = TSfromDate.getTime();

    let TSToDate = new Date(ShowDate.getFullYear(), ShowDate.getMonth(), ShowDate.getDate(),23,59,59);
    let tsTo = TSToDate.getTime();
    
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let ret = new Map;
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let resAttribute = (row.attribute);
        if((attributeNumbers.includes( resAttribute )) 
          && (row.valueTSfrom >= tsFrom)
          && (row.valueTSfrom <= tsTo)){
          ret.set(resAttribute,row);
        }
      }

      return ret;
    });
  }

  static async getAllDayValues(user: string,ShowDate: Date, Exclude: Object ){
      //console.log(toRaw(ShowDate))
      if(!(ShowDate instanceof Date)){
        //console.log('is not Date');
        /* @ts-ignore */
        if(typeof ShowDate._value == 'object'){
          //console.log('is object');
          /* @ts-ignore */
          if(ShowDate._value instanceof Date){
            //console.log('is Date');
            /* @ts-ignore */
            ShowDate = ShowDate._value;
          }
        }
      }

      let excludeKeys = Object.keys(Exclude);

      let TSfromDate = new Date(ShowDate.getFullYear(), ShowDate.getMonth(), ShowDate.getDate(),0,0,0);
      let tsFrom = TSfromDate.getTime();

      let TSToDate = new Date(ShowDate.getFullYear(), ShowDate.getMonth(), ShowDate.getDate(),23,59,59);
      let tsTo = TSToDate.getTime();

      //let myAttributeNames = DataSafe.myAttributes();
      //console.log(myAttributeNames);
      return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
        //console.log(res)
        //let ret = new Map;
        let ret = [];
        for(var i =0; i < res.length; i++){
          let row = res[i];
          let resAttribute = (row.attribute);
          if(((row.valueTSfrom >= tsFrom)
                && (row.valueTSfrom <= tsTo))
                && !(excludeKeys.includes( resAttribute.toString() ))
            ){
              //row.attributeName = myAttributeNames[resAttribute];
            //ret.set(resAttribute,row);
            ret.push(row)
          }
        }
        //console.log(ret)
        return ret;
      });

  }


  static async getValuesToDaySortedTimeRange(user: string, From: Date, To: Date ){
   
    //console.log(To)
    let TSfromDate = From;
    TSfromDate.setHours(0)
    TSfromDate.setMinutes(0)
    TSfromDate.setSeconds(0)
    TSfromDate.setMilliseconds(0)

    let tsFrom = TSfromDate.getTime();

    let TSToDate = To;
    TSToDate.setHours(23)
    TSToDate.setMinutes(59)
    TSToDate.setSeconds(59)
    TSToDate.setMilliseconds(999)
    let tsTo = TSToDate.getTime();
    
    return await db.datasafe.where("appUser").equals(user).toArray().then((res) => {
      let myAttributesDe = DataSafe.myAttributesDe();
      let myAttributes = DataSafe.myAttributes();
      let attributesWithoutTimeRelevance = DataSafe.attributesWithoutTimeRelevance();
      let datefunction = 'dateToString';
      let ret = {};
      //console.log(res)
      for(var i =0; i < res.length; i++){
        let row = res[i];
        let resAttribute = (row.attribute);
        let RowDate = new Date();
        RowDate.setTime(row["valueTSfrom"]);
        RowDate.setHours(12);
        RowDate.setMinutes(0)
        RowDate.setSeconds(0)
        RowDate.setMilliseconds(0)
        let RetTimeKey = RowDate.getFullYear+''+RowDate
        //console.log(row)
        /* @ts-ignore */
        if( 
           (((row.valueTSfrom >= tsFrom)
              && (row.valueTSfrom <= tsTo))
              /* @ts-ignore */
              //|| (attributesWithoutTimeRelevance.includes( parseInt(resAttribute)))
          )){


            /* @ts-ignore */
            if(typeof ret[RowDate.getTime()] == 'undefined'){
              /* @ts-ignore */
              ret[RowDate.getTime()] = {};
            }
            //console.log(ret[RowDate.getTime()][row.attribute])
            /* @ts-ignore */
            if(typeof ret[RowDate.getTime()][row.attribute] == 'undefined'){
              /* @ts-ignore */
              ret[RowDate.getTime()][row.attribute] = {};
            }
            //console.log(ret[RowDate.getTime()][row.attribute][row["valueTSfrom"]])
            /* @ts-ignore */
            if(typeof ret[RowDate.getTime()][row.attribute][row["valueTSfrom"]] == 'undefined'){
              /* @ts-ignore */
              ret[RowDate.getTime()][row.attribute][row["valueTSfrom"]] = [];
            }
            //console.log(ret[RowDate.getTime()][row.attribute][row["valueTSfrom"]])
            //console.log(ret)
            
            
            /* @ts-ignore */
            row["attribute_eng"] = myAttributes[row.attribute];
            /* @ts-ignore */
            row["attribute_de"] = myAttributesDe[row.attribute];
            /* @ts-ignore */
            row["valuefrom"] = DataSafe.ifDateOrNothing(row["valueTSfrom"],datefunction);
            /* @ts-ignore */
            row["valueto"] = DataSafe.ifDateOrNothing(row["valueTSto"],datefunction);
            /* @ts-ignore */
            row["valueinsert"] = DataSafe.ifDateOrNothing(row["valueTSinsert"],datefunction);
            /* @ts-ignore */
            ret[RowDate.getTime()][row.attribute][row["valueTSfrom"]].push(row);
            //console.log(ret)
        }
      }
      //console.log(ret)
      return ret;
    });
  }
}